import '@styles/common.less';
import '@styles/layout.less';
import './news.less';
import '@common';

document.addEventListener('DOMContentLoaded', () => {
  const isNewsDetailPage = Boolean(document.querySelector('.section-news-detail'));
  if (!isNewsDetailPage) return;

  const navLinks = document.querySelectorAll('.site-header a[href^="./"]');
  navLinks.forEach((link) => {
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('./')) return;
    link.setAttribute('href', `../${href.slice(2)}`);
  });
});
